import React from "react";

export default function index() {
  return (
    <section>
      <h1>Educación</h1>

      <h2>Ironhack Mexico</h2>

      <h3>Desarrollo Web, Programación</h3>

      <h4>Octubre 2021 - Diciembre 2021</h4>

      <p>Bootcamp de 9 semanas intensivas de Desarrollo Web.</p>
      <p>Creando proyectos front end y full stack.</p>

      <hr className="border-b-2 border-rose-100"/>

      <h2>Universidad Nacional Autónoma de México</h2>

      <h3>Maestría en Administración</h3>

      <h4>2014 - 2016</h4>

      <p>
        Maestría para la dirección, desarrollo, consultoría, promoción y
        fortalecimiento de organizaciones pertenecientes a los Sistemas de
        Salud, en un marco de ética y responsabilidad social, con capacidad para
        formular e implementar estrategias, participar en la toma de decisiones
        y resolución de problemas que enfrentan estas organizaciones.
      </p>

      <hr className="border-b-2 border-rose-100"/>

      <h2>Universidad Autónoma de Yucatán</h2>

      <h3> Urgencias Médico Quirúrgicas</h3>

      <h4>2011 - 2014</h4>

      <p>
        Residencia de tres años en hospital de segundo nivel atendiendo
        pacientes en área de urgencias, bajo tutela de un grupo de
        especialistas.
      </p>
    </section>
  );
}
